import { render, staticRenderFns } from "./AnalyticsHomepage.vue?vue&type=template&id=52cb800c&"
import script from "./AnalyticsHomepage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsHomepage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports